var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumblrDesktopLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 17,
  viewBox: "0 0 19 17",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.953 13.357C2.947 11.281-.367 8.441.033 5.184.033 2.816 1.91 0 5.098 0 7.487 0 9.52 2.317 9.52 2.317S11.143 0 13.917 0c3.173 0 5.05 2.815 5.05 5.205.4 3.263-2.922 6.11-4.935 8.186-2.174 2.242-3.488 3.586-4.532 3.586-1.029 0-2.36-1.356-4.547-3.62m1.314-1.292c-1.452-1.503-4.226-3.558-4.28-6.715 0-2.513 2.078-3.313 3.187-3.313 1.73 0 4.326 3.396 4.326 3.396s2.446-3.436 4.453-3.356c1.099-.08 2.977.76 2.977 3.288-.008 3.157-2.634 5.221-4.091 6.724-1.574 1.623-2.925 2.995-3.339 2.81-.298.185-1.65-1.196-3.233-2.834"
})));
export default SvgTumblrDesktopLike;